// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.meeting-countdown {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 12px 10px;
  background: linear-gradient(135deg, #101f38 0%, #0a1628 100%);
  border-radius: 12px;
}

.countdown-unit {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 42px;
}

.countdown-value {
  font-size: 20px;
  font-weight: 800;
  color: #ffffff;
  letter-spacing: 0.5px;
  font-variant-numeric: tabular-nums;
}

.countdown-label {
  font-size: 9px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #3d8a76;
  margin-top: 2px;
}

.countdown-sep {
  color: rgba(255, 255, 255, 0.35);
  font-weight: 700;
  font-size: 18px;
  transform: translateY(-6px);
}

.meeting-countdown.ended {
  display: block;
  text-align: center;
  padding: 14px 10px;
  background: rgba(16, 31, 56, 0.08);
  color: #48546b;
  font-weight: 700;
  font-size: 13px;
  border-radius: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/admin/components/MeetingCountdown.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,6DAA6D;EAC7D,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,kCAAkC;EAClC,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB","sourcesContent":[".meeting-countdown {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 6px;\r\n  padding: 12px 10px;\r\n  background: linear-gradient(135deg, #101f38 0%, #0a1628 100%);\r\n  border-radius: 12px;\r\n}\r\n\r\n.countdown-unit {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  min-width: 42px;\r\n}\r\n\r\n.countdown-value {\r\n  font-size: 20px;\r\n  font-weight: 800;\r\n  color: #ffffff;\r\n  letter-spacing: 0.5px;\r\n  font-variant-numeric: tabular-nums;\r\n}\r\n\r\n.countdown-label {\r\n  font-size: 9px;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.06em;\r\n  color: #3d8a76;\r\n  margin-top: 2px;\r\n}\r\n\r\n.countdown-sep {\r\n  color: rgba(255, 255, 255, 0.35);\r\n  font-weight: 700;\r\n  font-size: 18px;\r\n  transform: translateY(-6px);\r\n}\r\n\r\n.meeting-countdown.ended {\r\n  display: block;\r\n  text-align: center;\r\n  padding: 14px 10px;\r\n  background: rgba(16, 31, 56, 0.08);\r\n  color: #48546b;\r\n  font-weight: 700;\r\n  font-size: 13px;\r\n  border-radius: 12px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
